module.exports = __webpack_public_path__ + "static/img/t47.9011bf0e.png";